module.exports = __webpack_public_path__ + "static/img/bot.6bd137a.png";


//////////////////
// WEBPACK FOOTER
// ./src/newChat/bot.png
// module id = z49z
// module chunks = 1